import { capitalize } from "@gettactic/helpers";
import type { ReservationCategory } from "./groupReservations";

/**
 * Human label for a reservation category.
 *
 * Parking follows the organization's custom verbiage (some customers call it
 * "bay", "stall", …), matching {@link getResourceTypeName}.
 */
export const getReservationCategoryLabel = (
  category: ReservationCategory,
  parkingVerbiage: string | null
): string => {
  switch (category) {
    case "desk":
      return "Desks";
    case "meeting_room":
      return "Rooms";
    case "parking":
      return parkingVerbiage ? capitalize(`${parkingVerbiage}s`) : "Parking";
    default:
      return "Other";
  }
};
